<template>
  <div class="home" :style="{minHeight: bodyHeight + 'px'}">  
    <router-view></router-view>
    <!-- Copyright©{{new Date().getFullYear()}}  -->
    <div class="copyright">版权所有 © 2020 CHINA LAB 备案序号：京ICP备06050757号-15</div>
  </div>
</template>

<script>
  
export default {
  name: 'ex-register', 
  props: {},
  data () {
    return { 
      arr: [{ id: 1, path: 'https://synairsoft.obs.cn-north-4.myhuaweicloud.com/cloudExhibition/imgs/202305/a1bbd6f3b8634fed9f64a0a214e0ccbf.jpg' }],
      enArr: [{ id: 1, path: 'https://api.chinadentalshow.com:8000/uploaded/file/202208/1e7dbd8bf75247fcba874d82301c8544.png' }],
      bodyHeight: "800px",
    };
  }, 
  created () {
    this.bodyHeight = window.innerHeight ? window.innerHeight : "800";
  },
}

</script>

<style lang="scss" scoped>
.home {
  background: #fff;
//   height: 20000px;

}
.copyright {
  margin: 0 auto;
  padding-bottom: 64px;
  text-align: center;
  font-size: 12px;
  color: #999;
  padding: 0 20px 30px;
}
</style>
